import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { techSearchParams } from '#/service/utils';

const StyledLink = styled(Link)`
  font: var(--fontStyleFootnote);
`;

StyledLink.displayName = 'StyledLink';

interface InputLinkProps {
  label?: string;
  path?: string;
}

const InputLink: FC<InputLinkProps> = ({ label, path }) => {
  const location = useLocation();

  return (
    <StyledLink
      data-testid="input-link"
      to={{
        pathname: path,
        search: techSearchParams(location.search),
      }}
    >
      {label}
    </StyledLink>
  );
};

export default InputLink;
